import { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getMiniGamesList } from 'src/store/selectors';
import { useTranslation } from "react-i18next";
import { changeGameBoxView } from "src/store/actionCreators/ui";
import './styles.scss';

interface MiniGamesProps {
    bgWidgetAudio: HTMLAudioElement;
}

const MiniGames: FC<MiniGamesProps> = ({bgWidgetAudio}) => {
    const { t } = useTranslation();
    const miniGamesList = useSelector(getMiniGamesList);
    const dispatch = useDispatch();

    const handleClick = () => {
        bgWidgetAudio.pause();
        bgWidgetAudio.currentTime = 0;
        window.parent.postMessage(
            { type: "OPEN_MINI_GAME" }, "*");
        setTimeout(() => {
            dispatch(changeGameBoxView(''));
        }, 500);
    };

    return (
        <div className="mini-games-container">
            <p className="mini-games-container__info">{t('mini_games_info')}</p>
            <div className="mini-games-container__list">
                {miniGamesList.map(
                    (game: {
                        id: number;
                        thumbnail: string | undefined;
                        name: string | undefined;
                    }) => (
                        <div className="mini-game" key={game.id} onClick={() => handleClick()}>
                            <img src={game.thumbnail} alt={game.name} />
                        </div>
                    )
                )}
            </div>
        </div>
    );
};

export default MiniGames;
